import { TextField } from "@mui/material";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";

import { CryptorFormData } from "@/pages/cryptor/utils/cryptor.schema";

interface CryptorDescriptionAIFieldProps {
  control: Control<CryptorFormData, {}>;
}

const CryptorDescriptionAIField: FC<CryptorDescriptionAIFieldProps> = ({
  control,
}) => {
  return (
    <Controller
      control={control}
      name="descriptionForAI"
      render={({ field, fieldState }) => (
        <TextField
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Description IA"
          value={field.value}
          onChange={field.onChange}
          margin="normal"
          error={fieldState.invalid}
          fullWidth
        />
      )}
    />
  );
};

export default CryptorDescriptionAIField;
